import { Stack, Text, Image, Button } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import React from "react";
import { FLY_ANYWHERE_MAP_INDEX_ENTRY_IMAGE_URL } from "../../../../constants";
import styles from "./FlyAnywhereMapBanner.module.css";
import useCreateUrl from "../../../../hooks/useCreateUrl";
import useUserAgent from "../../../../hooks/useUserAgent";

const FlyAnywhereMapBanner = () => {
  const i18n = useI18n();
  const { createUrlWithApiPrefix } = useCreateUrl();
  const { isMobile } = useUserAgent();

  return (
    <Stack direction="column" alignItems="start" justifyContent="start">
      <Stack.Item grow>
        <Text variant="headline_2">{i18n.trans(t("flights_cat_exploreanywhere_mapview_title"))}</Text>
      </Stack.Item>
      <div className={styles.mapImageContainer}>
        <Image
          src={FLY_ANYWHERE_MAP_INDEX_ENTRY_IMAGE_URL}
          contentMode="fill"
          borderRadius={200}
          width="100%"
          height={250}
          className={styles.mapImage}
          alt={i18n.trans(t("flights_cat_exploreanywhere_mapview_title"))}
        />
        <Button
          className={isMobile ? styles.exploreAnywhereButtonMobile : styles.exploreAnywhereButton}
          text={i18n.trans(t("flights_cat_exploreanywhere_mapview_cta"))}
          variant="elevated"
          type="button"
          size="large"
          attributes={{
            "aria-label": i18n.trans(t("flights_cat_exploreanywhere_mapview_cta"))
          }}
          href={createUrlWithApiPrefix("/fly-anywhere?flyAnywhereView=map")}
        />
      </div>
    </Stack>
  );
};

export default FlyAnywhereMapBanner;
